/* eslint-disable @typescript-eslint/unbound-method */
import { FC, useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import { NavigateList } from 'routes/routesList';
import { useIdleTimer } from 'react-idle-timer';
import { useDispatch, useSelector } from 'react-redux';
import { getIsAuth } from 'redux/reducers/auth/selectors';
import { getOrganization } from 'redux/reducers/user/selectors';
import { Screensaver } from 'components/Screesnaver';
import {
	refreshTokenByTimeOutSuccess,
	saveUrl,
	setLocalStorageMessage,
} from 'redux/reducers/auth/reducer';
import { collectDeviceInfo } from 'services/deviceInfo';

export const App: FC = () => {
	const dispatch = useDispatch();
	const [stateIdle, setStateIdle] = useState<string>('Active');

	const loggedIn = useSelector(getIsAuth);
	const organization = useSelector(getOrganization);

	const onIdle = () => {
		setStateIdle('Idle');
	};

	useIdleTimer({
		onIdle,
		timeout: 300_000, // 300_000,
		throttle: 100_000,
		disabled: !loggedIn || !organization,
	});

	window.addEventListener('unload', () => {
		const url =
			window.location.pathname === '/sign-in'
				? '/shops'
				: window.location.pathname + window.location.search;
		dispatch(refreshTokenByTimeOutSuccess());
		dispatch(saveUrl(url));
		dispatch(setLocalStorageMessage(`unload ${new Date().toISOString()}`));
	});

	console.log('------App------');
	console.log(window.location.pathname);
	console.log(window.location.search);

	console.info('Device Information:', collectDeviceInfo());

	return (
		<BrowserRouter>
			<Screensaver
				open={stateIdle === 'Idle'}
				handleClose={() => {
					setStateIdle('Active');
				}}
			/>
			<NavigateList />
		</BrowserRouter>
	);
};
